import "./scss/index.scss";
import { Button, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();


  return (
    <Stack className="error" justifyItems="center" pt={8}
      position='fixed'
      justifyContent="center"
      alignItems="center"
      sx={{
        inset: 0,
        zIndex: 9999,
        bgcolor: 'background.default',
      }}  
    >
      <Typography variant="h3" fontWeight={700}>
        404
      </Typography>

      <Typography variant="title" textTransform="uppercase">Page Not Found</Typography>

      <Typography my={2} variant="body1" color="text.secondary" textAlign="center" sx={{ maxWidth: 640 }}>
        We could not find the page you are looking for. It may have been moved, renamed, or
        might never have existed. Try returning to the homepage or go back to the previous page.
      </Typography>

      <Stack direction="row" spacing={2}>
        <Button variant="contained" color="primary" onClick={() => navigate("/")}>Go to Home</Button>
        <Button variant="outlined" color="primary" onClick={() => navigate(-1)}>Go back</Button>
      </Stack>
    </Stack>
  );
};

export default NotFound;
